// extracted by mini-css-extract-plugin
export default {"section":"Xdl8Ayth4Ie6kYN8U2Wf"};